import { gql } from '@apollo/client';

export const GET_ALL_PRODUCT_TYPE_DETAILS = gql`
  query GetAllProductTypeDetails {
    productTypeDetails {
      id
      type
      saleAs
      hasInsurance
      hasTripFee
      hasYoungsterFee
      taxable
      isOn
      createdAt
    }
  }
`;

export const UPDATE_PRODUCT_TYPE_DETAILS = gql`
  mutation UpdateProductTypeDetails($id: String!, $input: UpdateProductTypeDetailsInput!) {
    updateProductTypeDetails(id: $id, input: $input) {
      id
      type
      saleAs
      hasInsurance
      hasTripFee
      hasYoungsterFee
      taxable
      isOn
      createdAt
    }
  }
`;

export const CREATE_PRODUCT_TYPE_DETAILS = gql`
  mutation CreateProductTypeDetails($input: CreateProductTypeDetailsInput!) {
    createProductTypeDetails(input: $input) {
      id
      type
      saleAs
      hasInsurance
      hasTripFee
      hasYoungsterFee
      taxable
      isOn
      createdAt
    }
  }
`;
